import { render, staticRenderFns } from "./LocalModalMask.vue?vue&type=template&id=3f12e726&"
import script from "./LocalModalMask.vue?vue&type=script&lang=js&"
export * from "./LocalModalMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports